module.exports = __webpack_public_path__ + "img/logo.89231f5c.png";